import MainConnection from "./MainConnection";

export default {
  requestGetCurrentUser: async function() {
    try {
      const requestURL = "/users/me";
      const response = await MainConnection.request().get(requestURL);
      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestGetUserList: async function(page) {
    try {
      const requestURL = "/users?page=" + page;
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestSearchUsers: async function(searchText) {
    try {
      const requestUrl = "/users?search=" + searchText;
      const response = await MainConnection.request().get(requestUrl);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestCreateNewUser: async function(params) {
    try {
      const requestURL = "/users";
      const response = await MainConnection.request().post(requestURL, params);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestGetUserById: async function(userId) {
    try {
      const requestURL = "/users/" + userId;
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestUpdateUserById: async function(userId, params) {
    try {
      const requestURL = "/users/" + userId;
      const response = await MainConnection.request().patch(requestURL, params);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestRemoveUserById: async function(userId) {
    try {
      const requestURL = "/users/" + userId;
      const response = await MainConnection.request().delete(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestLogout: async function() {
    try {
      const requestURL = "/auth/logout";
      const response = await MainConnection.request().post(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestWebSocketAuth: async function() {
    try {
      const requestURL = "/auth/websocket";
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestInitialFunnel: async function(date) {
    try {
      const requestURL = "/home/funnel?date=" + date;
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
